<!-- =========================================================================================
  File Name: ExhibitorList.vue
  Description: Exhibitor List Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style scoped>
.option-inner-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}
.option-inner-wrap li {
  width: 50%;
  padding: 10px;
}
.popup-info-tooltips.info-top-custom-tooltip {
  top: -300px !important;
}
</style>
<template>
  <div id="page-user-list" v-show="pageLoaded">
    <div class="header-custome">
      <h3>
        Resources
        <span>{{
          gridSelectedRows ? "(Rows Selected: " + gridSelectedRows + ")" : ""
        }}</span>
      </h3>
      <div class="knowlg-base-wrap-sec hidden">
        <a href="/pages/knowledge-base/category-exhibitors/question-3">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-help-circle"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </span>
          Need help with this section?
        </a>
      </div>
    </div>

    <div
      class="vx-card p-6 blank-attendee" v-show="resourceData1.length < 1"
    >
      <div class="entity-create-sec">
        <div class="emtity-icon">
          <img src="../../assets/images/blank-page-images/resources.png"/>
          <!--<feather-icon class="" icon="UsersIcon" />-->
        </div>
        <div class="entity-create-desc">
          <h2>Upload Resources</h2>
          <p>Resources are a great way to showcase rich content in different categories which attendees can search and filter. Supported media types - PDF, MP4, JPG, External URL, Embed Widget</p>
          <div class="entity-setup-buttons">
            <vs-button
              color="primary"
              type="border"
              class="new-entity-add-button"
               @click="ManageCategory()"
              >MANAGE CATEGORIES</vs-button
            >
            <vs-button
              color="primary"
              type="filled"
              class="new-entity-add-button"
              @click="addResources()"
              >ADD RESOUCES</vs-button
            >
            
          </div>
        </div>
      </div>
    </div>

    <div class="vx-card p-6" v-show="resourceData1.length > 0">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  resourceData1.length - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : resourceData1.length
                }}
                of {{ resourceData1.length }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <span id="exhibitorCount" style="display: none">{{
              resourceData1.length
            }}</span>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <vs-button type="border mr-4" v-on:click="ManageCategory()"
          >Manage Categories</vs-button
        >
        <!--ADD -->
        <vs-button color="rgb(76, 139, 246)" class="mr-4" type="filled" v-on:click="addResources()"
          >Add Resources</vs-button
        >
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="deleteRecord()">
              <span class="flex items-center">
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Delete Resource(s)</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

        <!-- Exhibitor Category -->
        <vs-popup
          class="holamundo manage-resource-category"
          title="Category List"
          :active.sync="popupActiveCategory"
        >
          <span id="custom-tooltip1">copied!</span>
          <div class="vx-col w-full text-right mb-5">
            <vs-button color="success" type="gradient" @click="addCategory()"
              >Add Category</vs-button
            >
          </div>
          <input
            style="position: absolute; top: -20px"
            type="text"
            id="myInput"
          />

          <div class="flex flex-wrap items-center">
            <div class="flex-grow">
              <!-- AG GRID CAtegory -->
              <vs-dropdown vs-trigger-click class="cursor-pointer mb-5">
                <div
                  class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <span class="mr-2"
                    >{{
                      currentPageCategory * paginationPageSizeCategory -
                      (paginationPageSizeCategory - 1)
                    }}
                    -
                    {{
                      categoryList.length -
                        currentPageCategory * paginationPageSizeCategory >
                      0
                        ? currentPageCategory * paginationPageSizeCategory
                        : categoryList.length
                    }}
                    of {{ categoryList.length }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    @click="gridCategoryApi.paginationSetPageSize(10)"
                  >
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="gridCategoryApi.paginationSetPageSize(20)"
                  >
                    <span>20</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="gridCategoryApi.paginationSetPageSize(25)"
                  >
                    <span>25</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="gridCategoryApi.paginationSetPageSize(30)"
                  >
                    <span>30</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
              <vs-table :data="categoryList">
                <template slot="thead">
                  <vs-th>Category Name</vs-th>
                  <vs-th>Last Updated</vs-th>
                  <vs-th>Copy Link</vs-th>
                  <vs-th>Hide From Resource List</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].Name">{{
                      data[indextr].Name
                    }}</vs-td>
                    <vs-td :data="data[indextr].ModifiedTime">{{
                      data[indextr].ModifiedTime
                    }}</vs-td>
                    <vs-td :data="data[indextr].Id">
                      <feather-icon
                        icon="CopyIcon"
                        title="Copy Link"
                        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                        @click="copyLinkCategory(data[indextr])"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].Id">
                      <span
                        class="feather-icon select-none relative switch-publish ml-4"
                        title="Category Show/ Hide"
                        @click="hideCategory(data[indextr])"
                      >
                        <vs-switch v-model="data[indextr].IsHidden">
                        </vs-switch>
                      </span>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <!-- AG GRID CAtegory Ends-->
            </div>
          </div>
        </vs-popup>
        <!-- Exhibitor Category Ends-->
        <!-- Exhibitor Add Category -->
        <vs-popup
          class="holamundo"
          title="Add Category"
          :active.sync="popupActiveAddCategory"
        >
          <vs-input
            label="Category Name"
            class="mt-5 w-full"
            name="CategoryName"
            v-model="categoryName"
            data-vv-as="Category Name"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('CategoryName')"
            >{{ errors.first("CategoryName") }}</span
          >
          <br />
          <label> Show / Hide Category</label>
          <vs-switch v-model="showHideCategory" title="Hide / Show Category">
          </vs-switch>
          <br />
          <vs-button class="mr-6" v-on:click="saveCategory">Submit</vs-button>
          <vs-button
            type="border"
            color="danger"
            @click="popupActiveAddCategory = false"
            >Cancel</vs-button
          >
        </vs-popup>

        <vs-popup
          class="holamundo resource-add-pop"
          title="Add Resource"
          :active.sync="popupActiveAddResource"
        >
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <label>Resource Name</label>
              <vs-input
                class="w-full mb-3"
                name="ResourceName"
                v-model="resourceName"
              />
            </div>

            <div class="vx-col md:w-1/2 w-full">
              <label>Category</label>
              <v-select
                class="w-full"
                name="Category"
                :options="CategoryData"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="selectedCategory"
              />
            </div>
          </div>
          <label>Short Description</label>
          <textarea
            class="w-full mb-3"
            name="description"
            cols="40"
            rows="3"
            v-model="description"
          ></textarea>
          
          <br />
          <label class="mr-4">Type</label>
          <br />
          <br />
          <vs-radio
            v-model="resourceType"
            vs-value="pdf"
            class="mr-4"
            vs-name="theme-mode-light"
            @change="checkResourceUploaded()"
            >PDF</vs-radio
          >
          <vs-radio
            v-model="resourceType"
            vs-value="video"
            class="mr-4"
            vs-name="theme-mode-dark"
            @change="checkResourceUploaded()"
            >Video URL</vs-radio
          >
          <vs-radio
            v-model="resourceType"
            vs-value="image"
            class="mr-4"
            vs-name="theme-mode-semi-dark"
            @change="checkResourceUploaded()"
            >Image</vs-radio
          >
          <vs-radio
            v-model="resourceType"
            vs-value="code"
            class="mr-4"
            vs-name="theme-mode-semi-dark"
            @change="checkResourceUploaded()"
            >Embed Code</vs-radio
          >

          <vs-radio
            v-model="resourceType"
            vs-value="hyperLink"
            class="mr-4"
            vs-name="theme-mode-semi-dark"
            @change="checkResourceUploaded()"
            >Hyper Link</vs-radio
          >
          <br />
          <div
            class="vx-col md:w-12/12 w-full"
            v-if="
              resourceType == 'pdf' ||
              resourceType == 'video' ||
              resourceType == 'hyperLink'
            "
          >
            <div class="label-top">
              <label>Upload Cover Image</label>
              <!-- <div class="label-info">
                <feather-icon class="" icon="InfoIcon" title="Info Icon" />
                <div class="image-hotspot-info">
                  <p>
                    Booth hotspot image should be transparent PNG file 1170 x
                    600px. Please don't make any structural changes. Use the PSD
                    source file, you may change the colors, icons etc keeping
                    the same propotions. This is to ensure the file is
                    compatible with the hotspot zones in the template.
                  </p>
                </div>
              </div> -->
            </div>
            <div class="hotspot-imagelink-box-wrap">
              <vs-input
                class="inputx w-full"
                name="coverImageURL"
                v-model="coverImageURL"
              />
              <vs-button
                color="primary"
                type="filled"
                @click="$refs.upload_image.click()"
                size="small"
                class="upload-btn"
                >Upload</vs-button
              >
            </div>
            <div class="hotspot-image-box-wrapper">
              <img
                class="mr-2 rounded"
                v-show="coverImageURL"
                :src="coverImageURL"
              />
            </div>
            <input
              class="hidden"
              ref="upload_image"
              type="file"
              @change="UploadImage($event, 'coverImageURL', 'coverImageURL')"
              accept="image/*"
            />
          </div>
          <br />
          <div class="upload-file" v-if="resourceType == 'pdf'">
            <form>
              <div class="file-up-section">
                <p>Upload PDF file</p>

                <input type="file" id="pdf_file" accept=".pdf" />

                <vs-button
                  color="rgb(76, 139, 246)" type="filled"
                  class="sub-btn"
                  v-on:click="uploadResourceFiles"
                  >Upload</vs-button
                >
              </div>
            </form>
          </div>
          <div class="upload-file" v-else-if="resourceType == 'image'">
            <form>
              <div class="file-up-section">
                <p>Upload Image file</p>
                <input type="file" id="image_file" accept=".jpg,.png,.gif" />
                <vs-button
                  color="rgb(76, 139, 246)" type="filled"
                  class="sub-btn"
                  v-on:click="uploadResourceFiles"
                  >Upload</vs-button
                >
              </div>
            </form>
          </div>
          <div class="upload-file" v-else-if="resourceType == 'code'">
            <form>
              <div class="file-up-section">
                <p>Paste Your Embed Code</p>
                <textarea
                  class="mt-5 w-full"
                  name="embedCode"
                  cols="40"
                  rows="6"
                  v-model="embedCode"
                ></textarea>
              </div>
            </form>
          </div>
          <div class="upload-file" v-else-if="resourceType == 'video'">
            <form>
              <div class="file-up-section">
                <div class="vx-col md:w-3/3 w-full mt-2">
                  <div class="label-top" v-if="videoFileCheck == false">
                    <label>Embed Video Link(Youtube or Vimeo)</label>
                  </div>
                  <vs-input
                    class="inputx w-full"
                    name="videoLink"
                    v-model="videoLink"
                    v-if="videoFileCheck == false"
                  />
                </div>
                <p v-if="videoLink == '' && videoFileCheck == false">OR</p>
                <p v-if="videoLink == ''">
                  Upload your video(Max Size: 100 mb)
                </p>
                <input
                  type="file"
                  id="video_file"
                  accept=".mp4"
                  v-if="videoLink == ''"
                />
                <vs-button
                  color="rgb(76, 139, 246)" type="filled"
                  class="sub-btn"
                  v-on:click="uploadResourceFiles"
                  v-if="videoLink == ''"
                  >Upload</vs-button
                >
              </div>
            </form>
          </div>
          <div class="upload-file" v-else-if="resourceType == 'hyperLink'">
            <form>
              <div class="file-up-section">
                <p>Paste Resource HyperLink(Opens in new tab)</p>
                <vs-input
                  class="mt-5 w-full"
                  name="resourceHyperLink"
                  v-model="resourceHyperLink"
                />
              </div>
            </form>
          </div>
          <br />
          <vs-button class="mr-6" v-on:click="saveResource">Submit</vs-button>
          <vs-button
            type="border"
            color="danger"
            @click="popupActiveAddResource = false"
            >Cancel</vs-button
          >
        </vs-popup>
        <!-- Exhibitor Category Ends-->
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="resourceData1"
        rowSelection="multiple"
        rowMultiSelectWithClick="false"
        suppressRowClickSelection="true"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";

// Store Module
import moduleResourceManagement from "@/store/resource-management/moduleResourceManagement.js";
import moment from "moment-timezone";
// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import CellRendererPublishActions from "./cell-renderer/CellRendererPublishActions.vue";

let Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
import ls from "@/common/localStorage";
import { AgGridVueCategory } from "ag-grid-vue";
import vSelectCategory from "vue-select";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import Swal from "sweetalert2";
var cn = ls.getSessionEventCollectionName();
var vm;
export default {
  components: {
    AgGridVue,
    vSelect,
    swiper,
    swiperSlide,
    quillEditor,
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    CellRendererPublishActions,
    AgGridVueCategory,
    vSelectCategory,
  },
  componentsCategory: {
    //----------------------------
    // AgGridVueCategory,
    // vSelectCategory,
    // Cell Renderer categtory
    // CellRendererLinkCategory,
    // CellRendererStatusCategory,
    // CellRendererVerifiedCategory,
    // CategoryCellRendererActions,
  },
  data() {
    return {
      CustomDomain: "",
      pageLoaded: false,
      CategoryData: [],
      categoryList: [],
      categoryName: "",
      resourceData: [],
      resourceName: "",
      description: "",
      selectedCategory: "",
      showHideCategory: false,
      popupActiveCategory: false,
      popupActiveAddCategory: false,
      popupActiveAddResource: false,
      resourceType: null,
      uploadedResourcePath: null,
      videoLink: "",
      embedCode: "",
      coverImageURL: "",
      fileName: null,
      resourceHyperLink: null,
      videoFileCheck: false,
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" },
      ],

      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" },
      ],

      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ],

      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" },
      ],

      searchQuery: "",
      // AgGrid
      gridApi: null,
      gridSelectedRows: 0,
      gridCategoryApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      defaultColDefCategory: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      gridOptionsCategory: {},
      columnDefs: [
        {
          width: 50,
          checkboxSelection: true,
          filter: false,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          pinned: "left",
        },
        {
          headerName: "Name",
          field: "ResourceName",
          filter: true,
          width: 200,
          pinned: "left",
        },
        {
          headerName: "Type",
          field: "ResourceType",
          filter: true,
          width: 150,
        },
        {
          headerName: "Category",
          field: "Category",
          filter: true,
          cellRenderer: (value) => {
            return value.data.SelectedCategory.length > 0
              ? value.data.SelectedCategory[0].Name
              : "";
          },
          width: 140,
        },
        {
          headerName: "Uploaded Date Time",
          field: "UploadedTime",
          filter: true,
          cellRenderer: (value) => {
            return value.data
              ? this.SetTimeByZone(
                  new Date(value.data.CreatedTime.seconds * 1000).toUTCString(),
                  Session_Event_TZ
                )
              : "";
          },
          width: 250,
        },
        {
          headerName: "Actions",
          field: "transactions",
          width: 150,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: (params) => {
            return { flag: params.data.IsPublished, Id: params.data.Id };
          },
        },
        {
          headerName: "Pin/ Un-Pin",
          field: "transactions",
          width: 200,
          cellRendererFramework: "CellRendererPublishActions",
          cellRendererParams: (params) => {
            return { flag: params.data.IsPublished, Id: params.data.Id };
          },
        },
      ],

      columnDefsCategory: [
        {
          headerName: "Category Name",
          field: "Name",
          filter: true,
          width: 300,
        },
        {
          headerName: "Last Updated",
          field: "ModifiedTime",
          filter: true,
          width: 300,
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
        AgGridVueCategory,
        vSelectCategory,
        // CategoryCellRendererActions,
      },
      swiperOption: {
        spaceBetween: 30,
        centeredSlides: true,
        cycle: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  watch: {},
  computed: {
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    currentPageCategory: {
      get() {
        if (this.gridCategoryApi)
          return this.gridCategoryApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridCategoryApi.paginationGoToPage(val - 1);
      },
    },
    paginationPageSizeCategory() {
      if (this.gridCategoryApi)
        return this.gridCategoryApi.paginationGetPageSize();
      else return 10;
    },
    totalPagesCategory() {
      if (this.gridCategoryApi)
        return this.gridCategoryApi.paginationGetTotalPages();
      else return 0;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    resourceData1() {
      return this.$store.state.resourceManagement.resources;
    },
  },
  methods: {
    hideCategory(data) {
      this.$store
        .dispatch("resourceManagement/updateCategoryStatus", {
          id: data.Id,
          IsHidden: !data.IsHidden,
        })
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: "Status Changed",
            text: "Status changed successfully",
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm A");
      return date;
    },

    addResources() {
      this.fetchCategory();
      this.popupActiveCategory = false;
      this.popupActiveAddCategory = false;
      this.resourceName = null;
      this.description = null;
      this.selectedCategory = null;
      this.resourceType = null;
      this.resourceHyperLink = null;
      this.videoLink = "";
      this.embedCode = "";
      this.uploadedResourcePath = null;
      this.videoFileCheck = false;
      this.errors.clear();
      this.popupActiveAddResource = true;
      //this.$router.push(`/event/resources/add`).catch(() => {});
    },
    ManageCategory: function () {
      this.fetchCategory();
      this.popupActiveCategory = true;
    },
    addCategory: function () {
      this.errors.clear();
      this.popupActiveCategory = false;
      this.popupActiveAddCategory = true;
    },
    saveCategory: function () {
      var dt = this.categoryName;
      var toggle = this.showHideCategory;
      debugger;
      this.$store
        .dispatch("resourceManagement/addResourceCategory", {
          Name: dt,
          IsHidden: toggle,
        })
        .then((res) => {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Manage Category",
            text: "Category Added successfully.",
          });
        })
        .catch((err) => {
          console.error(err);
        });
      this.categoryName = null;
      this.popupActiveAddCategory = false;
      //------------------------------------------------------------------------------
    },
    fetchCategory() {
      this.$store
        .dispatch("resourceManagement/fetchCategory")
        .then((res) => {
          this.CategoryData = [];
          res.map((row) => {
            row.ModifiedTime = this.SetTimeByZone(
              new Date(row.CreatedTime.seconds * 1000).toUTCString(),
              Session_Event_TZ
            );
            this.CategoryData.push(row.Name);
          });
          this.categoryList = res;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    UploadImage(input, fieldName, fieldsrc) {
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        const bgImgfile = input.target.files[0];
        const metadata = { contentType: bgImgfile.type };
        const validImageTypes = ["image/jpeg", "image/png"];
        if (!validImageTypes.includes(bgImgfile.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let FileSize = bgImgfile.size / 1024 / 1024;
        if (FileSize > 10) {
          alert("Uploaded file size exceeds 10 MB");
          return false;
        }
        //this.data_local[fieldName] = bgImgfile;
        const reader = new FileReader();
        reader.onload = (e) => {
          vm.uploadFile(bgImgfile, fieldName, fieldsrc);
          //this[fieldsrc] = e.target.result;
        };

        reader.readAsDataURL(input.target.files[0]);
      }
    },
    uploadFile(file, fieldName, fieldsrc) {
      this.$vs.loading();
      this.$store
        .dispatch("resourceManagement/uploadFiles", {
          file: file,
          path: cn + "/Resources/",
        })
        .then((res) => {
          this.$vs.loading.close();
          this.coverImageURL = res;
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
    },
    saveResource() {
      debugger;
      if (this.resourceType == "video") {
        if (this.videoLink != "") {
          this.uploadedResourcePath = this.videoLink;
        }
      }

      if (
        this.uploadedResourcePath == null &&
        this.embedCode == "" &&
        this.videoLink == "" &&
        this.resourceHyperLink == null
      ) {
        alert("Resource Not Uploaded");
      } else {
        if (this.resourceName == null) {
          alert("Resource Name Cannot be blank");
        } else if (this.selectedCategory == null) {
          alert("Category Cannot be blank");
        } else {
          this.$vs.loading();
          var category = [];
          this.categoryList.map((row1) => {
            if (row1.Name == this.selectedCategory) {
              category.push({
                Id: row1.Id,
                Name: row1.Name,
              });
            }
          });
          this.$store
            .dispatch("resourceManagement/addResources", {
              resourceName: this.resourceName,
              description: this.description,
              selectedCategory: category,
              resourceType: this.resourceType,
              coverImageURL: this.coverImageURL,
              uploadedResourcePath: this.uploadedResourcePath,
              embedCode: this.embedCode,
              fileName: this.fileName,
              hyperLinkUrl: this.resourceHyperLink,
            })
            .then((res) => {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Resources",
                text: "Resource Added successfully.",
              });
              this.popupActiveAddResource = false;
              this.resourceName = null;
              this.description = null;
              this.selectedCategory = null;
              this.resourceType = null;
              this.coverImageURL = null;
              this.uploadedResourcePath = null;
              this.videoLink = "";
              this.embedCode = "";
              this.fileName = null;
              this.resourceHyperLink = null;
              this.videoFileCheck = false;
              this.fetchAllResources();
              this.$vs.loading.close();
            })
            .catch((err) => {
              console.error(err);
              this.$vs.loading.close();
            });
        }
      }
    },
    uploadResourceFiles() {
      let FileSize;
      if (this.resourceType == "pdf") {
        var pdfFile = document.getElementById("pdf_file").files;
        FileSize = pdfFile[0].size / 1024 / 1024;
        if (FileSize > 20) {
          alert("Uploaded file size exceeds 20 MB");
          return false;
        } else {
          this.fileName = pdfFile[0].name;
          vm.uploadResource(pdfFile[0], "/Resources/pdfs/");
        }
      } else if (this.resourceType == "image") {
        var imageFile = document.getElementById("image_file").files;
        FileSize = imageFile[0].size / 1024 / 1024;
        if (FileSize > 10) {
          alert("Uploaded file size exceeds 10 MB");
          return false;
        } else {
          this.fileName = imageFile[0].name;
          vm.uploadResource(imageFile[0], "/Resources/images/");
        }
      } else if (this.resourceType == "video") {
        var videoFile = document.getElementById("video_file").files;
        FileSize = videoFile[0].size / 1024 / 1024;
        if (FileSize > 100) {
          alert("Uploaded file size exceeds 100 MB");
          return false;
        } else {
          this.fileName = videoFile[0].name;
          this.videoFileCheck = true;
          vm.uploadResource(videoFile[0], "/Resources/video/");
        }
      }
    },
    uploadResource(file, path) {
      this.$vs.loading();
      this.$store
        .dispatch("resourceManagement/uploadFiles", {
          file: file,
          path: cn + path,
        })
        .then((res) => {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Resource",
            text: "Resource Uploaded Successfully.",
          });
          this.uploadedResourcePath = res;
          this.$vs.loading.close();
        })
        .catch((err) => {
          this.$vs.loading.close();
        });
    },
    fetchAllResources() {
      this.$vs.loading();
      this.$store
        .dispatch("resourceManagement/fetchAllResources")
        .then((res) => {
          this.pageLoaded = true;
          this.$vs.loading.close();
          res.map((row) => {
            row.UploadedTime = this.SetTimeByZone(
              new Date(row.CreatedTime.seconds * 1000).toUTCString(),
              Session_Event_TZ
            );
            if (row.SelectedCategory[0] != undefined) {
              row.Category = row.SelectedCategory[0].Name;
            }
          });
          this.resourceData = res;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    checkResourceUploaded() {
      if (this.resourceType == "pdf") {
        reset($("#pdf_file"));
        this.uploadedResourcePath = null;
        this.embedCode = "";
        this.resourceHyperLink = null;
        this.videoLink = "";
      } else if (this.resourceType == "image") {
        reset($("#image_file"));
        this.uploadedResourcePath = null;
        this.embedCode = "";
        this.resourceHyperLink = null;
        this.videoLink = "";
      } else if (this.resourceType == "video") {
        reset($("#video_file"));
        this.uploadedResourcePath = null;
        this.embedCode = "";
        this.resourceHyperLink = null;
        this.videoLink = "";
        this.videoFileCheck = false;
      } else if (this.resourceType == "hyperLink") {
        this.uploadedResourcePath = null;
        this.embedCode = "";
        this.resourceHyperLink = null;
        this.videoLink = "";
      } else {
        this.uploadedResourcePath = null;
        this.embedCode = "";
        this.resourceHyperLink = null;
        this.videoLink = "";
      }
    },
    copyLinkCategory(data) {
      var copyTxt = "/resources?cat=" + data.Id;
      $("#myInput").val(copyTxt);
      var ct = document.getElementById("myInput");
      ct.select();
      ct.setSelectionRange(0, 99999);
      document.getElementById("custom-tooltip1").style.display = "inline";
      document.execCommand("copy");
      setTimeout(function () {
        document.getElementById("custom-tooltip1").style.display = "none";
      }, 1000);
    },
    deleteRecord() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length) {
        const { value: text } = Swal.fire({
          title: "Do you want to Delete these Resource's ?",
          input: "text",
          inputPlaceholder: "Type 'delete' and hit the Submit button",
          showCancelButton: true,
          confirmButtonText: "Submit",
          inputValidator: (value) => {
            if (value.toLocaleLowerCase().trim() == "delete") {
              this.deleteRecords(selectedRows);
            } else {
              return "Try again! Please type 'delete' and hit Submit.";
            }
          },
        });
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Recepient",
          text: "Please Select Record!",
          acceptText: "OK",
        });
      }
    },
    deleteRecords(data) {
     data.map((row) => {
      this.$vs.loading();
      this.$store
        .dispatch("resourceManagement/removeRecords", {
          data: row.Id,
        })
        .then((res) => {
          //alert(res.message)
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Delete",
            text: res.message,
          });
          this.gridApi.deselectAll();
          this.fetchAllResources();
          this.$vs.loading.close();
          
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
      });
      
    },
  },
  mounted() {
    window.reset = function (e) {
      e.wrap("<form>").closest("form").get(0).reset();
      e.unwrap();
    };
    this.gridOptions.api.showLoadingOverlay();
    this.gridApi = this.gridOptions.api;
    this.gridCategoryApi = this.gridOptionsCategory.api;
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  created() {
    vm = this;
    if (!moduleResourceManagement.isRegistered) {
      this.$store.registerModule(
        "resourceManagement",
        moduleResourceManagement
      );
      moduleResourceManagement.isRegistered = true;
    }
    this.fetchCategory();
    this.fetchAllResources();
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
.image-hotspot-info {
  position: absolute;
  width: 423px;
  height: 167px;
  background: #ffff;
  z-index: 999;
  line-height: 25px;
  padding: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.6);
  border-radius: 5px;
  bottom: 22px;
  left: 0;
  display: none;
}
.label-info:hover .image-hotspot-info {
  display: block;
}
.hotspot-imagelink-box-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
}
.hotspot-imagelink-box-wrap .vs-con-input {
  padding-right: 10px;
}
.hotspot-image-box-wrapper {
  width: 100%;
  height: 241px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border: 1px solid #dfdfdf;
  margin: 10px 0;
}
.hotspot-image-box-wrapper img {
  width: 100%;
}
.label-top {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.video-embed-custom-tooltip {
  position: absolute;
  z-index: 99999;
  width: 460px;
  height: 326px;
  padding: 15px;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.4);
  background: #fff;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  top: 13px;
  display: none;
}
.label-info:hover .video-embed-custom-tooltip {
  display: flex;
}
#custom-tooltip1 {
  display: none;
  margin-left: 220px;
  padding: 5px 12px;
  background-color: #000000df;
  border-radius: 4px;
  color: #fff;
  text-align: center;
}
</style>

